import { useState } from 'react';
import { usePresets } from './usePresets.js';
import { Button } from '@/components/ui/Button.js';
import { TextField } from '@/components/ui/NumberField.js';

export function PresetsPanel() {
  const { presets, loading, error, save, load, remove } = usePresets();
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  return (
    <div className="border-t border-neutral-800 p-3 space-y-2">
      <h3 className="text-xs uppercase tracking-widest text-neutral-400">Presets</h3>
      <div className="flex gap-2">
        <TextField label="" aria-label="Preset name" value={name} onValueChange={setName} placeholder="Name this world" className="flex-1" />
        <div className="flex items-end">
          <Button
            variant="primary"
            disabled={saving || !name.trim()}
            onClick={async () => {
              setSaving(true);
              try { await save(name.trim()); setName(''); }
              finally { setSaving(false); }
            }}
          >
            {saving ? 'Saving…' : 'Save'}
          </Button>
        </div>
      </div>
      {error && <p className="text-xs text-red-400">{error}</p>}
      {loading && <p className="text-xs text-neutral-400">Loading…</p>}
      <ul className="space-y-1 max-h-48 overflow-y-auto">
        {presets.map((p) => (
          <li key={p.id} className="flex items-center gap-2 text-sm">
            <button
              onClick={() => load(p.id)}
              className="flex-1 text-left px-2 py-1 rounded hover:bg-neutral-800 truncate"
              title={`Palette: ${p.paletteId}`}
            >
              {p.name}
            </button>
            <Button variant="ghost" onClick={() => remove(p.id)} aria-label={`Delete ${p.name}`}>✕</Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
